eliminarOrden = function(e){
    var data = e.dataset;
    $("#form_eliminar_orden")[0].reset();
    $("#eliminar_orden_id").val(data.id);
    $("#eliminar_orden_nombre").html(`¿Deseas eliminar la orden de <strong>${data.nombre}</strong> de fecha <strong>${data.fecha}</strong>?`);
}
let mica_seleccionada = null;

eliminarMicaSeleccionada = function(e){
    $(e).closest('tr').remove();
    if($("#tbodyMicas").find("tr").length){
        $("#div_btn_micas").removeClass('d-none');
    }else
        $("#div_btn_micas").addClass('d-none');
}
eliminarMicaSemiterminadaSeleccionada = function(e){
    $(e).closest('tr').remove();
    if($("#tbodyMicasSemiterminadas").find("tr").length){
        $("#div_btn_micas_semiterminadas").removeClass('d-none');
    }else
        $("#div_btn_micas_semiterminadas").addClass('d-none');
}

selectMica = function(e){
    mica_seleccionada = e.dataset;
    $("#mica_orden_id").val(mica_seleccionada.id);
    $(".btn-micas").removeClass('active').removeClass('text-dark');
    e.classList.add('active');
    e.classList.add('text-dark');
    $("#div_cantidad_micas").removeClass('d-none');

    var id = $(this).data("id");
    var existingRow = $("#tbodyMicas").find("tr[data-id='" + mica_seleccionada.id + "']");
    if (existingRow.length) {
        var quantityCell = existingRow.find("input .cantidad");
        var currentQuantity = parseInt(quantityCell.value);
        quantityCell.value = currentQuantity + 1;
    } else {
        $("#tbodyMicas").append(`
                        <tr data-id="${mica_seleccionada.id}">
                            <td>${mica_seleccionada.nombre}</td>
                            <td>${mica_seleccionada.graduacion} ${mica_seleccionada.lado}</td>
                            <td><input type="number" required min="1" name="cantidades[${mica_seleccionada.id}]" value="1" class="cantidad" autocomplete="off" inputmode="numeric"></td>
                            <td>
                                <button type="button" 
                                class="btn btn-danger" onclick="eliminarMicaSeleccionada(this)">
                                <i class="fa fa-trash text-white"></i>
                                </button>
                            </td>
                        </tr>
                    `);
        $("#div_btn_micas").removeClass('d-none');
    }

}

selectedMica = function(){
    let html = "";
    let mica = $("#select_orden_mica option:selected")[0];
    if(mica){
        let datos = mica.dataset;
        $.ajax({
            method: 'POST',
            url: url_base+"/api/getMicasByTipoId",
            dataType: 'json',
            data: {
                'mica_id': mica.value
            },
            beforeSend: function(){
            },
            error: function(){
                console.error("error");
            },
            success: function(data){
                let tipoMica = data.tipo;
                var arrMicas = Object.entries(data.micas);
                let tipo_valor = tipoMica.tipo_valor;
                let tipo_esfera = tipoMica.tipo_esfera;
                $("#div_info_micas").html(data.html);
            }
        });
    }else{
        mica_seleccionada = null;
    }
}


validarTomaMica = function(e){
    if(mica_seleccionada!==null){
        let actual = mica_seleccionada.cantidad;
        let cantidad = e.value;
        let html = "";
        if(actual!=="" && cantidad!==""){
            let restante = parseFloat(actual) - parseFloat(cantidad);
            if(parseFloat(mica_seleccionada.minimo)!==null){
                if(restante<=0)
                    html =
                        `<div class="alert alert-danger text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> Al tomar esta cantidad el inventario de esta mica será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
                else if(restante<parseFloat(mica_seleccionada.minimo))
                    html =
                        `<div class="alert alert-warning text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> La cantidad mínima en inventario de esta mica es de <strong>${parseFloat(mica_seleccionada.minimo)}</strong>, al tomar esta cantidad el inventario de éste será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
            }
            $("#div_alerta_micas").html(html);
            $("#div_btn_micas").removeClass('d-none');
        }
    }
}


let mica_semiterminada_seleccionada = null;

selectMicaSemiterminada = function(e){
    mica_semiterminada_seleccionada = e.dataset;
    $("#mica_semiterminada_orden_id").val(mica_semiterminada_seleccionada.id);
    $(".btn-micas-semiterminadas").removeClass('active').removeClass('text-dark');
    e.classList.add('active');
    e.classList.add('text-dark');
    $("#div_cantidad_micas_semiterminadas").removeClass('d-none');

    var id = $(this).data("id");
    var existingRow = $("#tbodyMicasSemiterminadas").find("tr[data-id='" + mica_semiterminada_seleccionada.id + "']");
    if (existingRow.length) {
        var quantityCell = existingRow.find("input .cantidad");
        var currentQuantity = parseInt(quantityCell.value);
        quantityCell.value = currentQuantity + 1;
    } else {
        $("#tbodyMicasSemiterminadas").append(`
                        <tr data-id="${mica_semiterminada_seleccionada.id}">
                            <td>${mica_semiterminada_seleccionada.nombre}</td>
                            <td>${mica_semiterminada_seleccionada.graduacion.replace(',cantidad','')} ${mica_semiterminada_seleccionada.lado}</td>
                            <td><input type="number" required min="1" name="cantidades[${mica_semiterminada_seleccionada.id}]" value="1" class="cantidad" autocomplete="off" inputmode="numeric"></td>
                            <td>
                                <button type="button" 
                                class="btn btn-danger" onclick="eliminarMicaSemiterminadaSeleccionada(this)">
                                <i class="fa fa-trash text-white"></i>
                                </button>
                            </td>
                        </tr>
                    `);
        $("#div_btn_micas_semiterminadas").removeClass('d-none');
    }

}
selectedMicaSemiterminada = function(){
    let html = "";
    let mica = $("#select_orden_mica_semiterminada option:selected")[0];
    if(mica){
        let datos = mica.dataset;
        $.ajax({
            method: 'POST',
            url: url_base+"/api/getMicasSemiterminadasByTipoId",
            dataType: 'json',
            data: {
                'mica_id': mica.value
            },
            beforeSend: function(){
            },
            error: function(){
                console.error("error");
            },
            success: function(data){
                var arrMicas = Object.entries(data.micas);
                $("#div_info_micas_semiterminadas").html(data.html);
            }
        });
    }else{
        mica_seleccionada = null;
    }
}

validarTomaMicaSemiterminada = function(e){
    if(mica_semiterminada_seleccionada!==null){
        let actual = mica_semiterminada_seleccionada.cantidad;
        let cantidad = e.value;
        let html = "";
        if(actual!=="" && cantidad!==""){
            let restante = parseFloat(actual) - parseFloat(cantidad);
            if(parseFloat(mica_semiterminada_seleccionada.minimo)!==null){
                if(restante<=0)
                    html =
                        `<div class="alert alert-danger text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> Al tomar esta cantidad el inventario de esta mica semiterminada será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
                else if(restante<parseFloat(mica_semiterminada_seleccionada.minimo))
                    html =
                        `<div class="alert alert-warning text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> La cantidad mínima en inventario de esta mica semiterminada es de <strong>${parseFloat(mica_semiterminada_seleccionada.minimo)}</strong>, al tomar esta cantidad el inventario de éste será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
            }
            $("#div_alerta_micas_semiterminadas").html(html);
            $("#div_btn_micas_semiterminadas").removeClass('d-none');
        }
    }
}



cancelarAgregarOrden = function(){
    $(".btn-micas").removeClass('active').removeClass('text-dark');
    $("#div_cantidad_micas").removeClass('d-none');
    $("#cantidad_tomar").val("")
    $("#div_micas").addClass('d-none');
    $("#div_productos").addClass('d-none');
    $("#div_servicios").addClass('d-none');
    $(".btn-show").removeClass('btn-primary').addClass('btn-outline-primary');
    $("#div_alerta_micas").html("");
    $("#div_btn_micas").addClass('d-none');
}

showRegistro = function(e,tipo){
    $("#div_micas").addClass('d-none');
    $("#div_micas_semiterminadas").addClass('d-none');
    $("#div_micas_especiales").addClass('d-none');
    $("#div_productos").addClass('d-none');
    $("#div_servicios").addClass('d-none');
    $("#div_"+tipo).removeClass('d-none');
    $(".btn-show").removeClass('btn-primary').addClass('btn-outline-primary');
    e.classList.remove('btn-outline-primary');
    e.classList.add('btn-primary');
    $("#div_alerta_micas").html("");
    $("#div_btn_micas").addClass('d-none');
}

eliminarArticulo = function(id){
    $("#eliminar_articulo_id").val(id);
    $("#modalEliminarArticulo").modal("show");
}
validarTomaProducto = function(){
    let producto = $("#select_orden_producto option:selected")[0];
    if(producto){
        let datos = producto.dataset;
        let html = "";
        if(datos.cantidad!==""){
            let restante = parseFloat(datos.cantidad) - parseFloat(1);
            if(parseFloat(datos.minimo)!==null){
                if(restante<=0)
                    html =
                        `<div class="alert alert-danger text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> Al tomar este producto, su inventario será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
                else if(restante<parseFloat(datos.minimo))
                    html =
                        `<div class="alert alert-warning text-center">
                        <p class="m-0 p-0">
                            <strong>Advertencia</strong> La cantidad mínima en inventario de este producto <strong>${parseFloat(datos.minimo)}</strong>, al tomarlo el inventario de éste será de <strong>${restante}</strong>.
                        </p>
                        <p class="m-0 p-0">
                            ¿Deseas continuar?
                        </p>
                    </div>`;
            }
            $("#div_info_productos").html(html);
            $("#div_btn_productos").removeClass('d-none');
        }
    }
}

eliminarDescuentoOrden = function(id){
    $("#eliminar_descuento_id").val(id);
    $("#modal_eliminar_descuento").modal("show");
}

eliminarPagoOrden = function(id){
    $("#eliminar_pago_id").val(id);
    $("#modal_eliminar_pago").modal("show");
}

imprimirTicket = function(tipo,id){
    $.ajax({
        method: 'POST',
        url: url_base+"/getTicket",
        dataType: 'json',
        data: {
            _token: token.content,
            'tipo':tipo,
            'id': id
        },
        beforeSend: function(){
        },
        error: function(){
            console.error("error");
        },
        success: function(data){
            if (data && data.ticket){
                    $("#modalPrevisualizarDocumento").modal('show');
                    document.getElementById('previsualizar_documento_div').innerHTML=data.ticket;
            }
        }
    });
}
getMaterial = function(){
    var select = document.getElementById("consulta_id");
    var opcionSeleccionada = select.options[select.selectedIndex];
    let consulta = JSON.parse(opcionSeleccionada.dataset.consulta);
    $("#esfera_od").val(consulta.esfera_od);
    $("#cilindro_od").val(consulta.cilindro_od);
    $("#eje_od").val(consulta.eje_od);
    $("#add_od").val(consulta.add_od);
    $("#dist_od").val(consulta.dist_od);
    $("#altura_od").val(consulta.altura_od);
    $("#esfera_oi").val(consulta.esfera_oi);
    $("#cilindro_oi").val(consulta.cilindro_oi);
    $("#eje_oi").val(consulta.eje_oi);
    $("#add_oi").val(consulta.add_oi);
    $("#dist_oi").val(consulta.dist_oi);
    $("#altura_oi").val(consulta.altura_oi);
    $("#material_orden").val(consulta.material);
}

getConsultasCliente = function(){
    let id_cliente = $("#cliente_id").val();
    let consulta_id = $("#consulta_id").val();
    if(id_cliente)
    $.ajax({
        method: 'POST',
        url: url_base+"/api/getConsultasByClienteId",
        dataType: 'json',
        data: {
            'cliente_id': id_cliente
        },
        beforeSend: function(){
        },
        error: function(){
            console.error("error");
        },
        success: function(data){
            if (data && data.consultas)
                $("#consulta_id").html(data.consultas).val(consulta_id);
        }
    });
}

var input = document.getElementById("codigo_producto");
if(input){
    let html_productos = "";
    input.addEventListener("keyup", function(event) {
        if (event.key === "Enter") {
            if (input.value.length>0){
                $.ajax({
                    method: 'POST',
                    url: url_base+"/api/getProductoIdByCodigo",
                    dataType: 'json',
                    data: {
                        'codigo': input.value
                    },
                    beforeSend: function(){
                    },
                    error: function(){
                        console.error("error");
                    },
                    success: function(data){
                        if (data && data.existe){
                            $("#select_orden_producto").val(data.id).selectpicker('refresh').trigger('change');
                        }else{
                            html_productos =
                                `<div class="alert alert-danger text-center">
                                    <p class="m-0 p-0">
                                        <strong>Error</strong> Este código de producto no existe en inventario.
                                    </p>
                                </div>`;
                            $("#div_info_productos").html(html_productos);
                        }
                    }
                });
            }
            else{
                html_productos =
                    `<div class="alert alert-danger text-center">
                        <p class="m-0 p-0">
                            <strong>Error</strong> Introduce un código de producto válido.
                        </p>
                    </div>`;
                $("#div_info_productos").html(html_productos);
            }
        }
    });
}

turnarOrden = function(estatus,id_orden){
    let msg ="";
    switch (estatus){
        case 'en_laboratorio':
            msg="Esta acción enviará la órden a laboratorio para que pueda ser atendida.";
            break;
        case 'en_biselado':
            msg="Esta acción actualizará el estatus de la órden a en biselado.";
            break;
        case 'en_proceso':
            msg="Esta acción actualizará el estatus de la órden a en proceso.";
            break;
        case 'terminada':
            msg="Esta acción actualizará el estatus de la órden a terminada.";
            break;
        case 'entregada':
            msg="Esta acción actualizará el estatus de la órden a entregada.";
            break;
        case 'pagada':
            msg="Esta acción actualizará la órden como pagada.";
            break;
    }
    $("#parrafo_turno_orden").html(msg);
    $("#envio_orden_id").val(id_orden);
    $("#envio_estatus_codigo").val(estatus);
    $("#modalTurnarOrden").modal('show');
}

turnarOrdenes = function(estatus){
    let msg ="";
    switch (estatus){
        case 'en_laboratorio':
            msg="Esta acción enviará las ordenes a laboratorio para que puedan ser atendidas.";
            break;
        case 'en_biselado':
            msg="Esta acción actualizará el estatus de las ordenes a en biselado.";
            break;
        case 'en_proceso':
            msg="Esta acción actualizará el estatus de las ordenes a en proceso.";
            break;
        case 'terminada':
            msg="Esta acción actualizará el estatus de las ordenes a terminadas.";
            break;
        case 'entregada':
            msg="Esta acción actualizará el estatus de las ordenes a entregadas.";
            break;
        case 'pagada':
            msg="Esta acción actualizará la ordenes como pagadas.";
            break;
    }

    var valoresSeleccionados = [];
    $('input[name="ordenesEstatus[]"]:checked').each(function(){
        valoresSeleccionados.push($(this).val());
    });

    $("#parrafo_turno_orden").html(msg);
    $("#envio_ordenes").val(valoresSeleccionados);
    $("#envio_ordenes_estatus").val(estatus);
    $("#modalTurnarOrdenes").modal('show');
}
$('input[name="ordenesEstatus[]"]').change(function(){
    var cantidadSeleccionada = $('input[name="ordenesEstatus[]"]:checked').length;
    if(cantidadSeleccionada){
        $(".btn-turnar-ordenes").removeClass('disabled');
    }else{
        $(".btn-turnar-ordenes").addClass('disabled');
    }
});

modalEntregarOrden = function(){
    $("#form_entrega_ordenes")[0].reset();
    setTimeout(function(){$('#input_folio_orden').focus()},500);
}

entregarOrden = function(e){
    e.preventDefault();
    const form       = document.querySelector('#form_entrega_ordenes');
    const formData   = new FormData(form);
    formData.append('_token',token.content);
    $("#div_carga").removeClass('d-none');
    $("#div_alerta").html('');

    if($("#terminar_input")[0].checked || $("#entregar_input")[0].checked){
        axios.post(url_base+'/ordenes/entregarOrden',formData)
            .then(response => {
                if(response.data){
                    let datos = response.data;
                    if(datos.error && parseInt(datos.error)){
                        $("#div_carga").addClass('d-none');
                        $("#div_alerta").html(`
                        <div class="alert alert-warning text-center">${datos.mensaje}</div>
                    `);
                    }else{
                        $("#div_carga").addClass('d-none');
                        $("#div_alerta").html(`
                        <div class="alert alert-success text-center">${datos.mensaje}</div>
                    `);
                        Livewire.emit('resetTabla');
                    }
                    $('#input_folio_orden').val('')
                }
            })
            .catch(e => {
                $("#div_carga").addClass('d-none');
                $("#div_alerta").html(`
                <div class="alert alert-danger text-center">Error al entregar la órden</div>
            `);
                console.log(e);
            });
    }else{
        $("#div_carga").addClass('d-none');
        $("#div_alerta").html(`
                <div class="alert alert-danger text-center">Selecciona por lo menos alguna opción</div>
            `);

        $('#input_folio_orden').val('')
    }

}


buscarOrden = function(e){
    e.preventDefault();
    const form       = document.querySelector('#form_buscar_orden');
    const formData   = new FormData(form);
    formData.append('_token',token.content);
    axios.post(url_base+'/ordenes/buscarOrden',formData)
        .then(response => {
            if(response.data){
                let datos = response.data;
                if(datos.error && parseInt(datos.error)){
                    $("#alertas").html(`
                        <div class="alert alert-warning text-center">${datos.mensaje}</div>
                    `);
                    setTimeout(function(){
                        $("#alertas").html(``);
                    },3000);
                }else{
                    window.location.replace(datos.url);
                }
                $('#input_busqueda').val('');
            }
        })
        .catch(e => {
            $("#alertas").html(`
                <div class="alert alert-danger text-center">Error al buscar la órden</div>
            `);
            setTimeout(function(){
                $("#alertas").html(``);
            },3000);
            console.log(e);
        });

}